import { Button, Form } from 'antd';
import { FileAddOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TRY_THEN_BUY_FRAUD } from '../../../../constants/define/translation';

interface FormNoteProps {
  onSubmit: (value: string) => void;
  content?: string;
  placeholder: string;
}
export const FormNote = (props: FormNoteProps) => {
  const [form] = Form.useForm();
  const { onSubmit, content, placeholder } = props;
  const { t } = useTranslation(TRY_THEN_BUY_FRAUD);
  return (
    <>
      <Form layout="vertical" form={form} initialValues={{ note: content }} onFinish={onSubmit}>
        <div className="form-content py-2">
          <Form.Item name="note">
            <TextArea placeholder={placeholder} />
          </Form.Item>
          <div className="mt-2">
            <Form.Item shouldUpdate>
              {() => (
                <div className="d-flex justify-content-end">
                  <Button
                    type="primary"
                    size="large"
                    id="btnSubmitInput"
                    className="px-4 btn mt-3"
                    htmlType="submit"
                    icon={<FileAddOutlined />}
                  >
                    {content ? t('form.edit') : t('form.add')}
                  </Button>
                </div>
              )}
            </Form.Item>
          </div>
        </div>
      </Form>
    </>
  );
};
